import { render, staticRenderFns } from "./ForgetPwd.vue?vue&type=template&id=36363d79&"
import script from "./ForgetPwd.vue?vue&type=script&lang=js&"
export * from "./ForgetPwd.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPwd.vue?vue&type=style&index=0&id=36363d79&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports